import { Text } from '@servicetitan/anvil2';
import { FC } from 'react';
import * as Styles from './search-result.module.less';

/**
 * Highlights the text after the first occurrence of the highlight string (google style).
 * If the highlight string is not found, the original text is returned.
 * If the highlight string is empty, the original text is returned.
 */
export const HighlightedText: FC<{ text: string; highlight: string }> = ({ highlight, text }) => {
    if (!highlight) {
        return <Text>{text}</Text>;
    }

    const idx = text.toLowerCase().indexOf(highlight.toLowerCase());
    if (idx < 0) {
        return <Text>{text}</Text>;
    }
    const regularPart = text.substring(0, idx + highlight.length);
    const highlightedPart = text.substring(idx + highlight.length);
    return (
        <Text className={Styles.text}>
            <span>{regularPart}</span>
            <strong>{highlightedPart}</strong>
        </Text>
    );
};
